import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@uberall/zenit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import 'normalize.css';
import './fonts.css';
import './main.css';
import './i18n.ts';

import { AppRoutes } from './AppRoutes.tsx';
import { RequestAccessFormProvider } from './contexts/request-access-form-provider.tsx';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 10 * 60 * 1000, // 10 minutes
            gcTime: 15 * (60 * 1000), // 15 mins
        },
    },
});

Sentry.init({
    dsn: 'https://4aef7464328e329edf85a45e30f5c206@sentry.operations.uberall.com/78',
    environment: import.meta.env.PROD ? 'production' : 'development',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            networkCaptureBodies: true,
            networkDetailAllowUrls: [
                window.location.origin,
                'development.request-access.com',
                'request-access.com',
            ],
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <RequestAccessFormProvider>
                    {/* we add a dynamic basename for the development environment based on the feature branch name. 
                        There we have the url format of development.request-access.com/<my-branch-name>/<my-access-id>
                        while for production it is request-access.com/<my-access-id */}
                    <BrowserRouter basename={import.meta.env.VITE_BASE_PATH || ''}>
                        <AppRoutes />
                    </BrowserRouter>
                </RequestAccessFormProvider>
            </ThemeProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
